"use client";
// components/HeroSection.js
import React from 'react';
import './HeroSection.scss'; // Make sure to create and style this file accordingly

const HeroSection = ({ background, title, subtitle, buttonText, buttonLink }) => {
  return (
    <div
      className="hero-section img-fluid"
      style={{ backgroundImage: `url(${background})` }}
    >
      <div className="hero-content">
        <div className="row">
          <div className="col-12">
          <h1>{title}</h1>
          <span className='dash'>{subtitle}</span>
          </div>
          <div className="col-12">
          <button className="hero-button" onClick={() => window.location.href = buttonLink}>
          {buttonText}
        </button>
          </div>
        </div>
       
      
      </div>
      <div>
        
      </div>
    </div>
  );
};

export default HeroSection;
